export default "__VITE_ASSET__D569KIb___"